import React from "react";
import { Space, Typography } from "antd";
import { Trans, useTranslation } from "react-i18next";
import { GRAY_500 } from "../constant/colors";
import { sizes, fontWeights } from "../constant/styles";
import { FILE_TYPES } from "../constant/export";

const { Text } = Typography;

export const ExportModalContent = ({ count, fileType }) => {
  const { t } = useTranslation();
  const fileTypeText = fileType === FILE_TYPES.XLSX ? t("export.xlsx_option") : t("export.csv_option");

  return (
    <Space direction="vertical" spacing="large" style={{ width: "100%" }}>
      <div id="export-modal-description">
        <Text
          style={{
            fontSize: sizes.medium,
            color: GRAY_500
          }}
        >
          <Trans
            i18nKey="export.modal_summary"
            values={{ count: count?.toLocaleString(), fileType: fileTypeText }}
            components={{
              strong: <Text style={{ color: GRAY_500, fontWeight: fontWeights.bold }} strong />
            }}
          />
        </Text>
      </div>
      <div>
        <Text
          style={{
            fontSize: sizes.small,
            color: GRAY_500
          }}
        >
          <Trans
            i18nKey="export.modal_phi_warning_text"
            components={{ strong: <Text style={{ color: GRAY_500, fontWeight: fontWeights.bold }} strong /> }}
          />
        </Text>
      </div>
    </Space>
  );
};
